import React from "react";
import "@/App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/api";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Shopping from "./pages/Shopping";
import Menu from "./pages/Menu";
import ActualCosts from "./pages/ActualCosts";
import Cabins from "./pages/Cabins";
import Ship from "./pages/Ship";
import Users from "./pages/Users";
import Help from "./pages/Help";
import Anilar from "./pages/Anilar";
import ErrorBoundary from "./components/ErrorBoundary";

function Gate() {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "hsl(var(--background))" }}>
        <div className="text-sm" style={{ color: "hsl(var(--text-2))" }}>Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/sifre-yenile" replace />;
  return null;
}

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm" style={{ color: "hsl(var(--text-2))" }}>Yükleniyor...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/sifre-yenile" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user && !user.must_change_password) return <Navigate to="/" replace />;
  if (user && user.must_change_password) return <Navigate to="/sifre-yenile" replace />;
  return <Login />;
}

function ChangeRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;
  return <ChangePassword />;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/sifre-yenile" element={<ChangeRoute />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<ErrorBoundary><Dashboard /></ErrorBoundary>} />
              <Route path="/odemeler" element={<Navigate to="/muhasebe?tab=odemeler" replace />} />
              <Route path="/maliyet" element={<Navigate to="/muhasebe" replace />} />
              <Route path="/alisveris" element={<ErrorBoundary><Shopping /></ErrorBoundary>} />
              <Route path="/menu" element={<ErrorBoundary><Menu /></ErrorBoundary>} />
              <Route path="/muhasebe" element={<ErrorBoundary><ActualCosts /></ErrorBoundary>} />
              <Route path="/kabinler" element={<ErrorBoundary><Cabins /></ErrorBoundary>} />
              <Route path="/gemi" element={<ErrorBoundary><Ship /></ErrorBoundary>} />
              <Route path="/kullanicilar" element={<ErrorBoundary><Users /></ErrorBoundary>} />
              <Route path="/yardim" element={<ErrorBoundary><Help /></ErrorBoundary>} />
              <Route path="/albumum" element={<Navigate to="/anilar" replace />} />
              <Route path="/rota" element={<Navigate to="/anilar?tab=rota" replace />} />
              <Route path="/anilar" element={<ErrorBoundary><Anilar /></ErrorBoundary>} />
            </Route>
            <Route path="*" element={<Gate />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
